import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="w-full bg-white py-12 border-t-2 border-gray-200" data-id="element-205">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-206">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12" data-id="element-207">
          <div data-id="element-208">
            <div className="mb-6" data-id="element-209">
              <img src="https://cdn.magicpatterns.com/uploads/8EVxVy8dkAVEdmFcPkswyr/Caveo_2026_Logo.png" alt="Caveo Logo" className="h-8" data-id="element-210" />
            </div>
            <ul className="space-y-3" data-id="element-211">
              <li data-id="element-212">
                <Link to="/" className="text-gray-600 hover:text-[#631bb7] no-underline transition-colors" data-id="element-213">
                  Home
                </Link>
              </li>
              <li data-id="element-214">
                <Link to="/how-it-works" className="text-gray-600 hover:text-[#631bb7] no-underline transition-colors" data-id="element-215">
                  How It Works
                </Link>
              </li>
              <li data-id="element-216">
                <Link to="/resources" className="text-gray-600 hover:text-[#631bb7] no-underline transition-colors" data-id="element-217">
                  Guides
                </Link>
              </li>
              <li data-id="element-218">
                <Link to="/pricing" className="text-gray-600 hover:text-[#631bb7] no-underline transition-colors" data-id="element-219">
                  Pricing
                </Link>
              </li>
              <li data-id="element-220">
                <Link to="/about-us" className="text-gray-600 hover:text-[#631bb7] no-underline transition-colors" data-id="element-221">
                  About
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-222">
            <div className="text-lg font-semibold text-[#111111] mb-6" data-id="element-223">
              For You
            </div>
            <ul className="space-y-3" data-id="element-224">
              <li data-id="element-225">
                <Link to="/individuals" className="text-gray-600 hover:text-[#631bb7] no-underline transition-colors" data-id="element-226">
                  For Individuals
                </Link>
              </li>
              <li data-id="element-227">
                <Link to="/families" className="text-gray-600 hover:text-[#631bb7] no-underline transition-colors" data-id="element-228">
                  For Families
                </Link>
              </li>
              <li data-id="element-229">
                <Link to="/onboarding" className="text-gray-600 hover:text-[#631bb7] no-underline transition-colors" data-id="element-230">
                  Free Assessment
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-231">
            <div className="text-lg font-semibold text-[#111111] mb-6" data-id="element-232">
              Legal
            </div>
            <ul className="space-y-3" data-id="element-233">
              <li data-id="element-234">
                <Link to="/privacy" className="text-gray-600 hover:text-[#631bb7] no-underline transition-colors" data-id="element-235">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-236">
                <a href="/terms" className="text-gray-600 hover:text-[#631bb7] no-underline transition-colors" data-id="element-237">
                  Terms & Conditions
                </a>
              </li>
              <li data-id="element-238">
                <a href="/subscription" className="text-gray-600 hover:text-[#631bb7] no-underline transition-colors" data-id="element-239">
                  Subscription Terms
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-240">
            <div className="text-lg font-semibold text-[#111111] mb-6" data-id="element-241">
              Disclaimer
            </div>
            <p className="text-gray-600 text-sm leading-relaxed" data-id="element-242">
              Caveo as a family protection platform does not monitor private
              communications. Please consult with your family before making any
              safety decisions.
            </p>
          </div>
        </div>

        {/* Design Test Pages - Tucked Away */}
        <div className="mt-8 pt-6 border-t border-gray-100" data-id="element-243">
          <details className="text-xs text-gray-400" data-id="element-244">
            <summary className="cursor-pointer hover:text-gray-500 transition-colors" data-id="element-245">
              Design System Tests
            </summary>
            <div className="mt-3 flex flex-wrap gap-4" data-id="element-246">
              <Link to="/test/button-colors" className="hover:text-[#631bb7] transition-colors" data-id="element-247">
                Button Colors
              </Link>
              <Link to="/test/color-comparison" className="hover:text-[#631bb7] transition-colors" data-id="element-248">
                Color Comparison
              </Link>
              <Link to="/test/fonts" className="hover:text-[#631bb7] transition-colors" data-id="element-249">
                Font Test
              </Link>
              <Link to="/test/purple-colors" className="hover:text-[#631bb7] transition-colors" data-id="element-250">
                Purple Colors
              </Link>
              <Link to="/coming-soon" className="hover:text-[#631bb7] transition-colors" data-id="element-251">
                Coming Soon Page
              </Link>
              <Link to="/marketing" className="hover:text-[#631bb7] transition-colors" data-id="element-252">
                Marketing Landing Page
              </Link>
              <Link to="/onboarding" className="hover:text-[#631bb7] transition-colors" data-id="element-253">
                Onboarding Gate
              </Link>
              <Link to="/first-look" className="hover:text-[#631bb7] transition-colors" data-id="element-254">
                First Look Results
              </Link>
              <Link to="/quick-assessment" className="hover:text-[#631bb7] transition-colors" data-id="element-255">
                Quick Assessment
              </Link>
              <Link to="/signup" className="hover:text-[#631bb7] transition-colors" data-id="element-256">
                Signup Flow
              </Link>
              <Link to="/invite-family" className="hover:text-[#631bb7] transition-colors" data-id="element-257">
                Invite Family
              </Link>
              <Link to="/deep-assessment" className="hover:text-[#631bb7] transition-colors" data-id="element-258">
                Deep Assessment
              </Link>
              <Link to="/assessment-score" className="hover:text-[#631bb7] transition-colors" data-id="element-259">
                Assessment Score
              </Link>
              <Link to="/dashboard" className="hover:text-[#631bb7] transition-colors" data-id="element-260">
                Guardian Dashboard
              </Link>
              <Link to="/member-dashboard" className="hover:text-[#631bb7] transition-colors" data-id="element-261">
                Member Dashboard
              </Link>
              <Link to="/learn/module-7" className="hover:text-[#631bb7] transition-colors" data-id="element-262">
                Module 7: Scam Recognition
              </Link>
            </div>
          </details>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center" data-id="element-263">
          <div className="mb-4 md:mb-0" data-id="element-264">
            <img src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg" alt="Download on App Store" className="h-10 inline-block mr-4" data-id="element-265" />
            <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Get it on Google Play" className="h-10 inline-block" data-id="element-266" />
          </div>
          <div className="text-sm text-gray-500" data-id="element-267">
            © 2026 AppEmbrace, Inc. DBA Caveo. All rights reserved.
          </div>
        </div>
      </div>
    </footer>;
}